import { useHistory } from "react-router-dom";
import { Typography } from "../../shared/uikit/Typography";
import { CtaButton } from "./common/CtaButton";

interface ConversationClosedCtaProps {
  buttonLabel: string;
  subtitle?: string;
  title: string;
}

export const ConversationClosedCta = ({
  buttonLabel,
  subtitle,
  title,
}: ConversationClosedCtaProps) => {
  const history = useHistory();

  return (
    <div className="bg-primary flex flex-col items-center justify-center gap-4 py-8">
      <div className="flex flex-col items-center justify-center gap-1">
        <Typography.LabelMd weight="bold" color="text-primary">
          {title}
        </Typography.LabelMd>

        {subtitle && (
          <Typography.LabelSm weight="medium" color="text-tertiary">
            {subtitle}
          </Typography.LabelSm>
        )}
      </div>

      <CtaButton
        label={buttonLabel}
        onClick={() => {
          history.push("/");
        }}
      />
    </div>
  );
};
